<!--  -->
<template>
  <div class="layout">
    <div class="layout-header">
      <div class="logo">
        <img src="@/assets/logo.png" alt="" />
      </div>
      <div class="menu">
        <div class="login" @click="loginPortal" v-show="userInfo.name === ''">
          登录
        </div>
        <el-dropdown v-show="userInfo.name !== ''" @command="handleCommand">
          <div class="avatar flex" @click="popupShow = !popupShow">
            <el-avatar
              v-if="userInfo.photo"
              :size="32"
              :src="userInfo.photo"
            ></el-avatar>
            <img v-else src="@/assets/avatar.png" alt="" />
            <span>{{ userInfo.name }}</span>
            <i class="el-icon-arrow-down" style="color: #4e5766"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="userCenter">个人中心</el-dropdown-item>
            <el-dropdown-item command="out">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {
  getUserInfo,
  regUser,
  logout,
  getPortalConfig,
  getLoginApi,
} from "@/api/home";
export default {
  components: {},
  name: "Layout",
  data() {
    return {
      popupShow: false,
      userInfo: {
        name: "",
        photo: "",
      },
      portalInfo: {},
    };
  },
  watch: {},
  methods: {
    //登录
    loginPortal() {
      // getLoginApi()
      window.location.href = window.g.base_url + window.g.loginUrl;
    },

    async logout() {
      const res = await logout();
      window.location.replace(res);
    },

    handleCommand(command) {
      if (command == "out") {
        this.logout();
      }
      if (command == "userCenter") {
        if (window.g.personalCenterUrl) {
          window.location.href = window.g.personalCenterUrl;
        }
      }
    },

    getUserInfo() {
      getUserInfo().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else {
          this.loginPortal();
        }
      });
    },

    //查询配置信息
    async getPortalConfig() {
      getPortalConfig().then((res) => {
        this.portalInfo = res.data;
      });
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  created() {}, //生命周期 - 创建完成（可以访问当前this实例）
  beforeMount() {}, //生命周期 - 挂载之前
  mounted() {
    this.getUserInfo();
    // this.getPortalConfig();
  }, //生命周期 - 挂载完成（可以访问DOM元素）
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  deactivated() {}, //如果页面有keep-alive缓存功能，当组件被移除时，触发钩子函数deactivated
};
</script>
<style scoped lang="less">
// 定义设计稿基准宽度
@design-width: 1920px;
@design-height: var(--window-height);

// 计算vw值
.vw(@px) {
  return: (@px / @design-width) * 100vw;
}

// 计算vh值
.vh(@px) {
  return: calc((@px / @design-height) * 100vh);
}

.layout {
  height: 100vh;
  overflow: hidden;

  .layout-header {
    position: sticky;
    top: 0;
    left: 0;
    height: 7vh;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8faff;
    padding: 0 .vw(40px) [];
    z-index: 2;

    .logo {
      display: flex;

      img {
        width: 17vh;
      }
    }

    .menu {
      display: flex;
      align-items: center;

      & > div {
        display: flex;
        align-items: center;
        margin-left: .vw(20px) [];
        cursor: pointer;

        i {
          color: #ffffff;
        }
      }

      .avatar {
        color: #4e5766;
        position: relative;
        font-size: .vh(14px) [];

        img {
          width: .vw(32px) [];
          margin-right: .vw(8px) [];
        }

        span {
          margin-right: .vw(10px) [];
        }

        i {
          margin-top: .vw(5px) [];
        }

        .popup {
          position: absolute;
          top: .vh(38px) [];
          right: 0;
          background: #fafafa;
          border: 1px solid #e5e5e5;

          & > div {
            color: #333333;
            padding: .vh(10px) [] .vw(20px) [];
            font-size: 12px;
            white-space: nowrap;
          }
        }
      }

      .login {
        background: none;
        border: 1px solid #005eff;
        color: #005eff;
        padding: calc(.vw(4px) []) calc(.vw(15px) []);
        font-size: .vw(14px) [];
      }
    }

    .flex {
      display: flex;
      align-items: center;
    }
  }
}
</style>
